<template>
  <div>
    <div class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-input
          :paramsInput="paramsInput"
          :readonly="readonly"
          label="Значение"
          v-model="model.value"
        />
      </div>
    </div>
    <div
      v-if="isAdmin"
      class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-input
          :paramsInput="paramsInput"
          :readonly="readonly"
          label="Минимум"
          v-model="model.minValue"
        />
      </div>
    </div>
    <div
      v-if="isAdmin"
      class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-input
          :paramsInput="paramsInput"
          :readonly="readonly"
          label="Максимум"
          v-model="model.maxValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'setting-field-int',
  data: (vm) => ({
    model: { ...vm.value }
  }),
  watch: {
    model: {
      handler: function(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('session', ['isAdmin']),
    paramsInput () {
      return {
        type: 'number'
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    readonly: {
      type: Boolean
    }
  }
}
</script>
